import './ProductOfferingsEmptyPageCoCo.scss';

interface ProductEmptyPageProps {
  title: string;
  message: string;
}

export const ProductOfferingsEmptyPageCoCo = ({ title, message }: ProductEmptyPageProps) => {
  return (
    <section className="empty-page">
      <div className="empty-page-content">
        <h1 className="empty-page-title">{title}</h1>
        <p className="empty-page-description">{message}</p>
      </div>
    </section>
  );
};
